/**
 * Broadcasts — WhatsApp / Messenger / Instagram sends to a segment.
 *
 * Its own catalog file rather than more keys in en.ts, which is at 488 lines
 * and is the file every feature reaches for.
 */
export const enBroadcasts = {
  'broadcasts.title': 'Broadcasts',
  'broadcasts.subtitle': 'Send one message to everyone who has opted in.',
  'broadcasts.empty': 'No broadcasts yet',
  'broadcasts.emptyBody':
    'A broadcast goes to every contact who has opted in to that channel. Create one to see how many that is.',
  'broadcasts.new': 'New broadcast',
  'broadcasts.loadFailed': 'Could not load broadcasts. Please try again.',

  // Create form
  'broadcasts.nameLabel': 'Name',
  'broadcasts.namePlaceholder': 'Spring launch',
  'broadcasts.channelLabel': 'Channel',
  'broadcasts.messageLabel': 'Message',
  'broadcasts.messagePlaceholder': 'What do you want to say?',
  'broadcasts.templateLabel': 'Template name (WhatsApp, optional)',
  'broadcasts.templateHelp':
    'WhatsApp requires a pre-approved template outside the 24-hour reply window.',
  'broadcasts.create': 'Create draft',
  'broadcasts.creating': 'Creating…',
  'broadcasts.createFailed': 'Could not create the broadcast. Please try again.',
  'broadcasts.created': 'Draft created',
  'broadcasts.cancelForm': 'Cancel',
  'broadcasts.nameRequired': 'Enter a name for this broadcast.',
  'broadcasts.bodyRequired': 'Add a message or a WhatsApp template name.',

  // Send
  'broadcasts.send': 'Send',
  'broadcasts.sending': 'Sending…',
  'broadcasts.sendStarted': 'Broadcast started',
  'broadcasts.sendFailed': 'Could not start the broadcast. Please try again.',
  // The eligible count is the honest number: the consent filter usually puts
  // it far below the contact count, and a merchant should see that BEFORE
  // pressing send, not after.
  'broadcasts.confirmSend': 'Send "{name}" to {count} opted-in contacts?',
  'broadcasts.confirmSendZero':
    'No contacts have opted in to this channel yet, so this would reach nobody.',
  'broadcasts.eligible': '{count} eligible',

  // Cancel
  'broadcasts.cancelSend': 'Cancel',
  'broadcasts.cancelled': 'Broadcast cancelled',
  'broadcasts.cancelFailed': 'Could not cancel the broadcast. Please try again.',

  // Status labels
  'broadcasts.status.DRAFT': 'Draft',
  'broadcasts.status.SCHEDULED': 'Scheduled',
  'broadcasts.status.SENDING': 'Sending',
  'broadcasts.status.COMPLETED': 'Sent',
  'broadcasts.status.FAILED': 'Failed',
  'broadcasts.status.CANCELLED': 'Cancelled',

  'broadcasts.sentOf': '{sent} sent · {failed} failed',
} as const;
